
import { supabase } from '@/integrations/supabase/client';

/**
 * Fetch a recipient's profile information by email or ID
 * 
 * @param recipientEmail The email address of the recipient
 * @param userId Optional user ID if already known
 * @returns An object containing the recipient's name and other profile data
 */
export async function fetchRecipientProfile(recipientEmail: string, userId?: string) {
  try {
    let profileData;
    
    // If we have a userId, use that for lookup first (faster)
    if (userId) {
      const { data, error } = await supabase
        .from('profiles')
        .select('id, name, first_name, last_name')
        .eq('id', userId)
        .single();
        
      if (!error && data) {
        profileData = data;
      }
    }
    
    // If no userId or lookup failed, use email
    if (!profileData) {
      const { data, error } = await supabase
        .from('profiles')
        .select('id, name, first_name, last_name')
        .eq('email', recipientEmail)
        .single();
        
      if (error) {
        console.error('Error fetching profile by email:', error);
        return { recipientName: 'User' };
      }
      
      profileData = data;
    }
    
    // Determine the best name to use
    let recipientName = 'User';
    if (profileData) {
      if (profileData.name) {
        recipientName = profileData.name;
      } else if (profileData.first_name) {
        recipientName = profileData.first_name;
      }
    }
    
    return {
      recipientName,
      profile: profileData
    };
  } catch (error) {
    console.error('Error fetching recipient profile:', error);
    return { recipientName: 'User' };
  }
}
